import React, { Component } from 'react';
import { Link, useParams } from "react-router-dom";
import { Button, CircularProgress, Typography } from "@mui/material";
import { History, LocalMall, CheckCircle, Error } from "@mui/icons-material";
import { EPaymentStatus, Order } from '../../../classes/types/order/order';
import PaymentHandler from '../../../classes/methods/paymentMethods/paymentMethods';
import CartEvents from "../../../classes/events/CartEvents";

interface props {
    orderId: string;
}

interface state {
    loading: boolean;
    currentOrder: Order;
}

class OrderReceived extends Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {
            loading: true,
            currentOrder: new Order(),
        };
    }

    componentDidMount() {
        this.refreshData();
    }

    refreshData = () => {
        this.setState({ loading: true });
        PaymentHandler.verifyPayment(this.props.orderId).then((order: Order) => {
            CartEvents.callCartModifiedEvents();
            this.setState({
                currentOrder: order,
                loading: false,
            });
        });
    }

    render() {
        return (
            <div style={{ paddingTop: '2%', paddingBottom: '2%' }}>
                <div hidden={!this.state.loading}>
                    <CircularProgress />
                    <Typography>Verifica ordine in corso</Typography>
                </div>
                <div hidden={this.state.loading}>
                    <div hidden={this.state.currentOrder.paymentStatus !== EPaymentStatus.Paid}>
                        <CheckCircle style={{ fontSize: 128, color: 'green' }} />
                        <Typography variant="h4">Ordine verificato con successo!</Typography>
                        <Typography variant="h5">Grazie per aver scelto Gigabyte!</Typography>
                        <div style={{ marginTop: '1%' }}>
                            <Link to={"/ordini"}>
                                <Button startIcon={<History />} color="primary" variant="contained" style={{ marginRight: "2%" }}>
                                    Visualizza i tuoi ordini
                                </Button>
                            </Link>
                            <Link to={"/shop/page/1"}>
                                <Button startIcon={<LocalMall />} color="primary" variant="contained">
                                    Sfoglia il catalogo
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div hidden={this.state.currentOrder.paymentStatus !== EPaymentStatus.NotPaid}>
                        <Error style={{ fontSize: 128, color: 'red' }} />
                        <Typography variant="h4">Errore durante la verifica dell'ordine</Typography>
                        <Typography variant="h5">Si è verificato un errore durante la verifica dell'ordine</Typography>
                        <div style={{ marginTop: '1%' }}>
                            <Link to={"/ordini"}>
                                <Button startIcon={<History />} color="primary" variant="contained" style={{ marginRight: "2%" }}>
                                    Visualizza i tuoi ordini
                                </Button>
                            </Link>
                            <Link to={"/shop/page/1"}>
                                <Button startIcon={<LocalMall />} color="primary" variant="contained">
                                    Sfoglia il catalogo
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// --- Wrapper per React Router v6
export default function OrderReceivedWrapper() {
    const { id } = useParams<{ id: string }>();
    return <OrderReceived orderId={id || ""} />;
}
